module.exports = __webpack_public_path__ + "static/media/room3.dfd604d3.png";